import { Flex, Tag } from '@chakra-ui/react';
import { tagStyle } from 'shared/styles';

const TagsCell = ({ cell: { value } }: { cell: { value: string[] } }) => {
    const tagList = value.map((tagName: string) => (
        <Tag {...tagStyle} mb={2} mr={2} key={tagName}>
            {tagName}
        </Tag>
    ));

    return (
        <Flex width="100%" flexWrap="wrap">
            {tagList}
        </Flex>
    );
};

export default TagsCell;
